{
	"positions": {
		"ticker": "Тикер",
		"option": "Опцион",
		"marketValue": "Оценка",
		"quantity": "Кол-во",
		"priceAveragePrice": "Цена/ср.",
		"profitabilityPerDay": "P&L день $/%",
		"profitability": "P&L $/%",
		"actions": "Действия",
		"price": "Цена",
		"averagePrice": "Средняя цена",
		"empty": "Отсутствуют позиции",
		"transactionsEmpty": "Отсутствуют сделки",
		"position": "Позиция",
		"positionSuccessClose": "Ордер на закрытие создан",
		"couldn'tClosePosition": "Не удалось закрыть позицию.",
		"info": "Информация",
		"close": "Закрыть",
		"execution": "Исполнить",
		"sltp": "SL/TP",
		"edit": "Изменить",
		"share": "Доля",
		"total": "Всего"
	}
}
